<template>
  <div class="row section-row">
    <div class="col-lg-12 row-background-color">
      <div class="row table-head-row-background-color non-mobile-monitor-table">
        <div style="width: 8%">Vessel Name</div>
        <div style="width: 8%">Vessel Type</div>
        <div style="width: 8%">IMO Number</div>
        <div style="width: 8%">Capacity</div>
        <div style="width: 8%">Distance Traveled</div>
        <div style="width: 8%">CO2 Emitted</div>
        <div style="width: 10%">Estimated CII</div>
        <div style="width: 10%">Required CII</div>
        <div style="width: 6%">CII Δ</div>
        <div style="width: 6%">CII Δ%</div>
        <div style="width: 10%">Preliminary Rating</div>
        <div style="width: 10%">Ship Details</div>
      </div>


      <div class="row table-head-row-background-color mobile-monitor-table">
        <div style="width: 18%">Vessel Name</div>
        <div style="width: 16%">IMO Number</div>
        <!-- <div style="width: 8%">Gross Tonage</div>
        <div style="width: 8%">Distance Traveled</div> -->
        <!-- <div style="width: 12%">CO2 Emitted</div> -->
        <div style="width: 16%">Estimated CII</div>
        <!-- <div style="width: 10%">CII 2019Δ</div> -->
        <div style="width: 16%">Required CII</div>
        <!-- <div style="width: 10%">Reference</div> -->
        <div style="width: 17%">Preliminary Rating</div>
        <div style="width: 17%">Ship Details</div>
      </div>

      <div v-if="this.reports">
        <div
          v-for="report in reports.slice(this.queryStart, this.queryEnd)"
          :key="report.ShipId"
        >
          <EmsRow v-bind:row="report" @changedSelect="selectedRow" />
        </div>
      </div>

      <TableMenu
        v-bind:reports="this.reports"
        @changedSelect="changePageSelection"
      />
    </div>
  </div>
</template>

<script>
import EmsRow from "./EmsRow";
import TableMenu from "./TableMenu.vue";
export default {
  name: "EmsMonitorTable",
  props: ["reports"],
  components: {
    EmsRow,
    TableMenu,
  },
  data() {
    return {
      name: "EmsMonitorTable",
      queryStart: 0,
      queryEnd: 10,
    };
  },
  methods: {
    selectedRow: function (value) {
      this.$emit("changedSelect", value);
    },
    changePageSelection: function (value) {
      this.queryStart = value.start;
      this.queryEnd = value.end;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
